import { Fragment, useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { Autocomplete, TextField } from "@mui/material";

const SearchCriteria = ({ label, id, setValue, setOptionsData, selectedValue, onChange, error, helperText, disabled = false }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    const loading = open && isFetching;

    useEffect(() => {
        let active = true;
    
        if (!open || !isFetching) {
            return;
        }
    
        const fetchOptionsData = async () => {
            try {
                if (active) {
                    const filteredOptions = setOptionsData.filter(i => i && i[label] !== null && i[label] !== undefined);
                    const sortedOptions = [...filteredOptions].sort((a, b) => {
                        const aValue = a[label]?.toString().toLowerCase() || '';
                        const bValue = b[label]?.toString().toLowerCase() || '';
                        return aValue.localeCompare(bValue);
                    });
                    setOptions(sortedOptions);
                }
            } finally {
                if (active) setIsFetching(false);
            }
        };
    
        if (isFetching) {
            fetchOptionsData();
        }
    
        return () => {
            active = false;
        };
    }, [isFetching, open]);
    
    useEffect(() => {
        if (!open) {
            setOptions([]);
            setIsFetching(false);
        } else {
            setIsFetching(true);
        }
    }, [open]);

    const getOptionLabel = (option) => {
        if (!option) return '';
        return option[label] || '';
    };

    const isOptionEqualToValue = (option, value) => {
        return option?.Id === value?.Id;
    };

    return (
        <Autocomplete
            id={id}
            open={open}
            value={selectedValue || null}
            size="small"
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            onChange={(e, newValue) => {
                setValue(newValue); 
                if (onChange) onChange(e);
            }}
            options={options}
            disabled={disabled}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={error}
                    helperText={error ? helperText : ''}
                    slotProps={{
                        ...params.slotProps,
                        endAdornment: (
                            <Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </Fragment>
                        ),
                    }}
                />
            )}
        />
    );
};

export default SearchCriteria;